export enum QueryKey {
  Profile = "profileData",
  AllFactors = "factors",
  FeatureFlags = "featureFlags",
}
